import PicklistMetadata from "../PicklistMetadata";

// The relationship type picker on "Add related object".
//
// DISPLAYS SourceRelationshipName, NOT Name. The reader is standing on the parent record and the
// question is how the edge reads FROM HERE -- "is a component of" -- which is the source phrasing.
// The type's own name ("Component") is the administrator's label for the pair and says less at the
// point of choosing.
class ObjectRelationshipTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ObjectRelationshipType";
        this.bounded = true;
        this.enterpriseComponent = "ObjectRelationshipType";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"SourceRelationshipName": "ASC"};
        this.static = false;
        this.typeField = "SourceRelationshipName";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default ObjectRelationshipTypePicklistMetadata;
